import { ApiModel } from '@/api/api-model';
import { Consorcio } from './Consorcio';

export const API_TYPE_MODULOS_DEFAULT = 'administracion';

export class Administracion extends ApiModel {

  api_type = API_TYPE_MODULOS_DEFAULT;

  nombre: string;
  tiene_acuerdo_comercial: boolean;
  consorcios?: Consorcio[];
  agente?: string;
  admin_ppal_mail?: string;


  /**
   * Retorna el nombre de la administración formateado
   * [id] Nombre de la administración
   */
  get nombre_con_id_formateado() {
    return '[' + this.id + '] ' + this.nombre;
  }
}